export default __webpack_public_path__ + "static/media/kuosan.679de0a7.svg";